import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import List from '@/views/List.vue'
// import Workspace from '@/views/Workspace.vue'
import Terms from '@/views/Terms.vue'
import About from '@/views/About.vue'
import Developer from '@/views/Developer.vue'
import En from '@/views/En.vue'
import Howto from '@/views/Howto.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/en',
    name: 'En',
    component: En
  },
  {
    path: '/list',
    name: 'List',
    component: List
  },
  {
    path: '/workspace/:sheetNo',
    name: 'Workspace',
    component: () => import('@/views/Workspace.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/developer',
    name: 'Developer',
    component: Developer
  },
  {
    path: '/howto',
    name: 'Howto',
    component: Howto
  },
  {
    path: '/public/:PublicNo',
    name: 'Public',
    component: () => import('@/views/Public.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
